import { Button } from '@components/common/Button';
import { EditIcon } from '@components/common/Icons/EditIcon';
import { DeleteIcon } from '@components/common/Icons/DeleteIcon';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IStudentLoanProps } from './types';

export const StudentLoan: FC<IStudentLoanProps> = ({ borrower, monthlyPayment, onEdit, onDelete }) => {
  return (
    <div className={'flex flex-col items-center justify-between rounded-xl py-10 px-5 shadow-md'}>
      <div className={'flex flex-col items-center'}>
        <h3 className={'mt-0 text-center text-xl'}>{borrower}</h3>
        <div className={'flex'}>
          <p className={'mt-0 text-base text-gray-500'}>
            £ {monthlyPayment}{' '}
            <span className={'text-sm'}>
              <FormattedMessage id={'common.monthly'} />
            </span>
          </p>
        </div>
      </div>
      <div className={'flex'}>
        <Button size={'large'} color={'error'} variant={'text'} onClick={onDelete}>
          <DeleteIcon htmlColor={'grey'} />
        </Button>
        <Button size={'large'} color={'info'} variant={'text'} onClick={onEdit}>
          <EditIcon htmlColor={'grey'} />
        </Button>
      </div>
    </div>
  );
};
